import { Dialog, DialogContent } from "@material-ui/core";
import React from "react";
import { DialogTitle } from "../../../utils/DialogTitle";
import { Transition } from "../../../utils/DialogTitle";
import { TablaSuper } from "./tableSupervisor";

export const ModalAlcohol = ({ setopenMondal, isOpen, data, lisSupervisores }) => {

    const clearData = () => {
        setopenMondal(false)
        // setdataEdit({})
    }


    return (
        <>
            <div>
                <Dialog
                    onClose={(e) => { clearData() }}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%" }}
                    fullWidth={true}
                    maxWidth="sm"
                >
                    <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }} >
                        Supervisores {data.name}
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: '30px' }}>
                        <TablaSuper data={data} lisSupervisores={lisSupervisores} />
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}